import { styled } from '@compiled/react';

import { N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateListContainer = styled.div({
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ListWrapper = styled.div({
	overflow: 'auto',
	flex: '1 1 auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoriesWrapper = styled.div({
	margin: `${token('space.0', '0px')} ${token('space.050', '4px')} ${token('space.0', '0px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SortByWrapper = styled.div({
	margin: `0px 0px ${token('space.100', '8px')} ${token('space.050', '4px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InfiniteScrollWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginTop: '-200px',
	height: '200px' /* height and margin must result in 0 to avoid an inner scrollbar */,
	visibility: 'hidden' /* don't show the spinner */,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CountDisplayWrapper = styled.div({
	margin: `${token('space.100', '8px')} ${token('space.0', '0px')} ${token(
		'space.150',
		'12px',
	)} ${token('space.050', '4px')}`,
	paddingTop: `${token('space.025', '2px')}`,
	color: `${token('color.text', N500)}`,
});
